export default "__VITE_ASSET__38a525a3__"